import type { AreaCatalog } from '../area';
import type { proposalErrors as en } from '../en/proposalErrors';

export const proposalErrors = {
  'proposalErrors.path.unknownModule': 'Unbekannter Abschnitt im Feldpfad „{path}“.',
  'proposalErrors.path.missingField': 'Im Pfad „{path}“ fehlt das Feld.',
  'proposalErrors.path.notPlannable': '„{path}“ ist kein planbares Feld.',
  'proposalErrors.path.collection': '„{path}“ ist eine Sammlung und lässt sich nicht vormerken.',
  'proposalErrors.value.priority': 'Die Priorität muss must, should oder could sein.',
  'proposalErrors.proposal.ownerOnly': 'Nur wer den Vorschlag verwaltet, kann ihn ändern.',
  'proposalErrors.proposal.frozen':
    'Ein veröffentlichter Vorschlag ist eingefroren. Merke Änderungen in einem neuen Vorschlag vor (Nachtrag).',
  'proposalErrors.proposal.nothingStaged':
    'Nichts zu veröffentlichen: Merke zuerst mindestens eine Änderung vor.',
  'proposalErrors.proposal.nothingToPublish': 'Nichts zu veröffentlichen.',
  'proposalErrors.change.notFound': 'Änderungsvorschlag nicht gefunden.',
  'proposalErrors.change.resolved': 'Über diesen Änderungsvorschlag ist schon entschieden.',
  'proposalErrors.change.notPublished':
    'Nur die Änderungen eines veröffentlichten Vorschlags lassen sich übernehmen.',
  'proposalErrors.ask.noOwner':
    'Hier ist niemand verantwortlich, also gibt es niemanden zu fragen. Es ist nichts passiert.',
  'proposalErrors.ask.expired':
    'Diese Anfrage ist abgelaufen. Sie wurde abgelehnt und es ist nichts passiert.',
  'proposalErrors.ask.noAct': 'Diese Anfrage enthält keine Handlung.',
  'proposalErrors.ask.ownerOnly':
    'Nur Verantwortliche dieser Aufgabe können diese Anfrage beantworten.',
  'proposalErrors.plan.noOrg': 'Du bist in keiner Organisation Mitglied.',
  'proposalErrors.plan.personalSelf':
    'Einen persönlichen Plan kannst du nur für dich selbst erstellen.',
  'proposalErrors.plan.notFound': 'Plan nicht gefunden.',
  'proposalErrors.plan.closedToProposals':
    'Ein veröffentlichter Plan nimmt keine Vorschläge mehr an.',
  'proposalErrors.plan.closedToChanges':
    'Ein veröffentlichter Plan nimmt keine Änderungen mehr an. Beginne einen neuen Plan.',
  'proposalErrors.plan.memberOnly': 'Nur wer zum Plan gehört, kann dazu beitragen.',
  'proposalErrors.plan.otherOrg': 'Vorschlag und Plan gehören zu verschiedenen Organisationen.',
  'proposalErrors.plan.alreadyPublished': 'Der Plan ist schon veröffentlicht.',
  'proposalErrors.plan.ownerOnly': 'Nur wer den Plan verwaltet, kann ihn veröffentlichen.',
  'proposalErrors.plan.nothingToPublish':
    'Nichts zu veröffentlichen: Der Plan hat keine Vorschläge mit Änderungen.',
  'proposalErrors.verb.createPlan': 'einen Plan erstellen',
  'proposalErrors.verb.plan': 'planen',
} as const satisfies AreaCatalog<typeof en>;
